<template>
  <div class="about">
    <div class="banner">
      <img src="../../assets/images/about/banner.png" alt />
    </div>
    <!-- 价值观 -->
    <div class="values">
        <img src="../../assets/images/about/3d.png" alt="">
        <div class="dolls">
            <div class="valuesTitle">
                EIM价值观
            </div>
            <p class="text">
                公司自成立以来,始终秉持实现智能营销的愿景坚持"成就客户，
                成就伙伴”的价值观, 服务众多国际品牌,提供人力资源服务,
                市场活动策划与推广,公关/会务/培训/策划及执行,
                移动互联网应用开发与营销四大核心服务,帮助客户获得成功，
                追求客户满意,帮助伙伴不断成长,提升伙伴价值。
            </p>
        </div>

    </div>
    <!-- 团队风采 -->
    <div class="teamStyle">
        <div class="title">团队风采</div>
        <img src="../../assets/images/about/team.png" alt="">
    </div>
    <!-- 组织架构 -->
    <div class="organizationalStructure">
        <div class="title">组织架构</div>
        <img src="../../assets/images/about/framework.png" alt="">
    </div>
    <!-- 分支及联系方式 -->
    <div class="contactInformation">
        <div class="title">分支机构及联系方式</div>
        <ul class="contactInformationList">
            <li>
                <div class="cityTitle">重庆</div>
                <span>
                    <img src="../../assets/images/about/place.png" alt="">
                    重庆市南岸区南坪万达写字楼2栋16-11
                </span>
                <br>
                <span>
                    <img src="../../assets/images/about/tel.png" alt="">
                    联系电话：18696660893
                </span>
            </li>
            <li>
                <div class="cityTitle">北京</div>
                <span>
                    <img src="../../assets/images/about/place.png" alt="">
                    北京市朝阳区高碑店乡高碑店新村二区10号楼
                </span>
                <br>
                <span>
                    <img src="../../assets/images/about/tel.png" alt="">
                    联系电话：18611246802
                </span>
            </li>
            <li>
                <div class="cityTitle">上海</div>
                <span>
                    <img src="../../assets/images/about/place.png" alt="">
                    上海市静安区洛川中路1158号名仕街创意园区
                </span>
                <br>
                <span>
                    <img src="../../assets/images/about/tel.png" alt="">
                    联系电话：14726175803
                </span>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style scoped>
.about {
  width: 100%;
}
.about .banner {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
}
.about .banner img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  height: 100%;
}
/* 价值观 */
.about .values {
    width: 100%;
    max-width: 1100px;
    margin: 30px auto;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
}
@media screen and (min-width: 850px) {
    .about .values {
        height: 320px;
    }
    .about .values img {
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translate(0, -50%);
        z-index: 300;
    }
    .about .values .dolls {
        width: 80%;
        position: absolute;
        top: 10px;
        right: 10px;
        height: 300px;
        border: 1px solid rgb(235,89,25);
    }
    .about .values .dolls .valuesTitle{
        position: absolute;
        top: 20%;
        left: 30%;
        font-size: 22px;
        font-weight: 400;
    }
    .about .values .dolls .valuesTitle::after {
        content: "";
        width: 60px;
        height: 4px;
        background-color: rgb(235,89,25);
        position: absolute;
        bottom: -14px;
        left: 0;
    }
    .about .values .dolls .text {
        position: absolute;
        top: 40%;
        left: 30%;
        width: 510px;
        font-size: 14px;
        line-height: 30px;
    }
}
@media screen and (max-width: 849px) {
    .about .values img {
        width: 100%;
    }
    .about .values .dolls {
        width: 100%;
        box-sizing: border-box;
        margin-top: 20px;
        padding: 30px;
        border: 1px solid rgb(235,89,25);
    }
    .about .values .dolls .valuesTitle{
        font-size: 22px;
        font-weight: 400;
        position: relative;
    }
    .about .values .dolls .valuesTitle::after {
        content: "";
        width: 60px;
        height: 4px;
        background-color: rgb(235,89,25);
        position: absolute;
        bottom: -14px;
        left: 0;
    }
    .about .values .dolls .text {
        width: 100%;
        font-size: 14px;
        line-height: 30px;
        margin-top: 20px;
    }
}

/* 团队风采 */
.about .teamStyle {
    width: 100%;
    max-width: 1100px;
    margin: 10px auto;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}
.about .teamStyle .title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 24px;
    position: relative;
}
.about .teamStyle .title::after {
    content: "";
    display: block;
    position: absolute;
    width: 60px;
    height: 4px;
    background-color: rgb(235,89,25);
    bottom: -14px;
    left: 50%;
    transform: translate(-50%,0);
}
.about .teamStyle img {
    width: 100%;
}
/* 组织架构 */
.about .organizationalStructure {
    width: 100%;
    max-width: 1100px;
    margin: 30px auto;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}
.about .organizationalStructure .title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 24px;
    position: relative;
}
.about .organizationalStructure .title::after {
    content: "";
    display: block;
    position: absolute;
    width: 60px;
    height: 4px;
    background-color: rgb(235,89,25);
    bottom: -14px;
    left: 50%;
    transform: translate(-50%,0);
}
.about .organizationalStructure img {
    width: 100%;
}

/* 联系方式 */
.about .contactInformation {
    width: 100%;
    max-width: 1100px;
    margin: 10px auto;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}
.about .contactInformation .title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 24px;
    position: relative;
}
.about .contactInformation .title::after {
    content: "";
    display: block;
    position: absolute;
    width: 60px;
    height: 4px;
    background-color: rgb(235,89,25);
    bottom: -14px;
    left: 50%;
    transform: translate(-50%,0);
}
.about .contactInformation .contactInformationList {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.contactInformationList li {
    width: 340px;
    margin: 8px 6px;
}
.contactInformationList li .cityTitle {
    font-size: 22px;
    font-weight: 500;
    margin-left: 10px;
    position: relative;
}
.contactInformationList li .cityTitle::after {
    content: "";
    width: 4px;
    height: 26px;
    background-color: rgb(235,89,25);
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translate(0,-50%);
}
.contactInformationList li span {
    display: inline-block;
    height: 30px;
    margin: 4px 0;
    line-height: 30px;
}
.contactInformationList li span img {
    vertical-align: middle;
}
</style>
